/* src/app/modules_v2/finance/cash/components/cash-form-dialog/cash-form-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.cfd-header-text {
  min-width: 0;
  padding-right: 32px;
}
.cfd-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.cfd-uid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
  margin-top: 4px;
}
.cfd-uid__value {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 12px;
  color: #6b7280;
  overflow-wrap: anywhere;
}
.cfd-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.cfd-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.cfd-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
/*# sourceMappingURL=cash-form-dialog.component.css.map */
